import React from 'react'

const EmployeeLogActivities = () => {
    return (
        <div>
            Riwayat Aktifitas KAryawan
        </div>
    )
}

export default EmployeeLogActivities
